import core from './modules/core.de';
import mm from './modules/mm.de';
import wm from './modules/wm.de';
import admin from './modules/admin.de';
import einvoicing from './modules/einvoicing.de';
import pm from './modules/pm.de';
import material from './modules/material.de';
import ab from './modules/ab.de';
import abShell from './modules/abShell.de';
import abPdf from './modules/abPdf.de';
import abMap from './modules/abMap.de';

const de = { ...core, ...mm, ...wm, ...admin, ...einvoicing, ...pm, ...material, ...ab, ...abShell, ...abPdf, ...abMap };

export default de;
